import {
  AccordionButton as ChakraAccordionButton,
  useAccordionItemState,
  useAccordionStyles,
} from '@chakra-ui/react';
import type { AccordionButtonProps as ChakraAccordionButtonProps } from '@chakra-ui/react';
import type { Merge } from 'type-fest';

import { type IconProps } from '@frontend/components';
import { ChevronDownIcon } from '@frontend/components/src/components/mediaAndIcons/icons/iconSet';

export type AccordionButtonProps = Merge<
  ChakraAccordionButtonProps,
  { iconProps?: IconProps }
>;

export const AccordionButton = ({
  children,
  iconProps,
  ...props
}: AccordionButtonProps) => {
  const { isOpen } = useAccordionItemState();
  const { icon: iconStyles } = useAccordionStyles();

  const { sx: iconPropsSx, ...restIconProps } = iconProps ?? {};

  const iconSx = {
    transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
    ...iconPropsSx,
  };

  return (
    <ChakraAccordionButton {...props}>
      <ChevronDownIcon __css={iconStyles} sx={iconSx} {...restIconProps} />
      {children}
    </ChakraAccordionButton>
  );
};
